import { useEffect, useState } from 'preact/hooks'
import { SearchspringProduct } from '../fetchers/product'
import { useSearchspringFetcher } from '../fetchers/provider'
import { normaliseResults } from '../helpers/normalisers'

export function useSwatches(initialResult) {
  const [currentResult, setCurrentResult] = useState(initialResult)

  const { isLoading, refine } = useSearchspringFetcher(new SearchspringProduct(), {
    runOnMount: false,
    onFetch: handleFetch
  })

  async function handleFetch(data) {
    if (!isLoading && data.results.length > 0) {
      const [result] = normaliseResults(data.results)
      setCurrentResult(result)
    }
  }

  const updateSwatch = (handle) => {
    refine('handle', handle)
  }

  return { currentResult, isLoading, updateSwatch }
}
